/**
 * Çıkış Deposu mapping utility
 * Depo kodlarını isimlere çevirir
 */

const WAREHOUSE_MAP = {
  "1001": "Bursa",
  "5501": "Nurnberg"
};

/** 
 * Depo kodunu depo adına çevirir
 * @param {string|number} warehouseCode - Depo kodu
 * @returns {string} - Depo adı veya "-" eğer bulunamazsa
 */
export const getWarehouseName = (warehouseCode) => {
  if (!warehouseCode) return "-";
  const code = String(warehouseCode);
  return WAREHOUSE_MAP[code] || code;
};

export default {
  getWarehouseName,
  WAREHOUSE_MAP
};

